import * as React from "react";
import {FC, useEffect, useRef} from "react";

export const BackgroundImage:FC<{src: string} & React.HTMLAttributes<HTMLDivElement>> = ({src, ...rest}) => {
   const refbg = useRef(null)

   useEffect(() => {
      const bgImage = new Image();
      bgImage.onload = () => {
         let current = refbg?.current;
         if(current) {
            (current as any).style.backgroundImage = 'url(' + bgImage.src + ')';
         }
      }
      bgImage.src = src;
   }, [src])

   return <div ref={refbg} style={{
      backgroundImage: 'url("https://storageaccountourimbea2.blob.core.windows.net/web/c2sprogress.svg")',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center'
   }} {...rest}>&nbsp;</div>
}